
import {map, catchError} from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { NoticeToVacateSignature } from '../app/models/noticetovacatesignature';
import { DoorCode } from '../app/models/doorcode';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { SelfTourDates } from '../app/models/selftourdates';

@Injectable()

export class NtvService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router) { }

    getNoticeToVacateSignature(cancelToken: string) {
      //check if NTV is already canceled here, if so, render ntv canceled page
      return this.http.get(NtvService._API_ENDPOINT + 'NoticeToVacate/GetNoticeToVacateSignature?cancelToken=' + cancelToken)
      .pipe(
            catchError(this.handleError),
            map((response) => <NoticeToVacateSignature>(response))
        );
    }

    cancelNoticeToVacate(cancelNTVToken: string) {
      //cancelNTV, if returns true, render ntv canceled, if false, render error
      return this.http.post(NtvService._API_ENDPOINT + 'NoticeToVacate/CancelNoticeToVacateRecord?cancelToken=' +  cancelNTVToken, {})
      .pipe(
            catchError(this.handleError),
            map((response) => <boolean>(response))
        );
    }

    handleError(error: HttpErrorResponse | string | any) {
      let errMsg: string;
      if (error.status === 403) {
          this.router.navigate(['/logout']);
      }
      if (error.error  instanceof ErrorEvent) {
          const body = error.error;
          if (body.message) {
              errMsg = error.error.message;
          } else {
              const err = body;
              errMsg = `${error.statusText || ''} ${err}`;
          }
      } else {
          errMsg = error.message ? error.message : error.toString();
          if (errMsg.length === 0) {
              errMsg = 'There was an unknown error.  Please try again later';
          }
      }

      localStorage.setItem('NTVErrorMessage', errMsg);
      this.router.navigate(['ntv/ntverror']);
      return errMsg;
    }
}
